<template>
  <div>
    <div v-if="numberofrecords === 0" class="content">
      <div class="notification notification--info">
        <div class="notification__content">
          <h2 class="notification__title">{{ numberofrecords }} {{ resultaat }}</h2>
        </div>
      </div>
    </div>
      <span v-else class="is-h4">{{ numberofrecords }} {{ resultaat }}</span>
    <div class="content-background" v-for="school in collection"  v-bind:key="school.initiatiefId">
      <div class="content content--inpage">
        <a :href="'index.html#/gegevens/' + school.initiatiefId" class="underline is-h3">
          <span @click="selectGegevens(school)" >{{ school.naam }}</span>
        </a>
        <div>
					<span class="label label--transparant">{{ getYearFormatted(school) }}</span> 
          <span
            class="label"
            v-bind:class="[
              school.sector === 'PO' ? 'label--geel' : 'label--hemelblauw']">
            {{ toonSoort(school.sector) }}
          </span>

          <span v-for="soortOnderwijs in school.soortOnderwijs"
            v-bind:key="soortOnderwijs.indicatieId" >
            <span v-bind:class="[soortOnderwijs.ingetrokken ? 'label label--line-through' : 'label']">{{ toonOpleiding(soortOnderwijs.soortOnderwijs) }}</span>
            <button x-uno-tooltip="" class="icon icon-info" v-bind:title="labels.TOOLTIP" v-if="soortOnderwijs.ingetrokken"></button>
          </span>
        </div>
        <span class="meta" v-if="school.postcodeCijfers || school.plaatsnaam"><b>
            <svg class="icon-detail" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.62 101.3"><defs></defs><title>Pointer</title><path class="cls-1" d="M32.53.05A27.84,27.84,0,0,0,17.79,3.48C1.71,12-4.52,30.15,3.48,47.42S20.17,81.34,28.57,98.28c.86,1.75,2,3,4.23,3,2.74,0,3.68-1.91,4.66-3.85C44.58,83.32,51.73,69.2,58.77,55c3.49-7,6.84-14.19,6.85-22.22C65.62,13.75,49.88-.55,32.53.05Z"/><path d="M32.53.05c17.35-.6,33.09,13.7,33.09,32.76,0,8-3.36,15.2-6.85,22.22-7,14.17-14.19,28.29-21.31,42.42-1,1.94-1.92,3.87-4.66,3.85-2.24,0-3.37-1.27-4.23-3C20.17,81.34,11.43,64.56,3.48,47.42S1.71,12,17.79,3.48A27.84,27.84,0,0,1,32.53.05Zm.15,52A19.37,19.37,0,1,0,13.43,32.85,19.19,19.19,0,0,0,32.68,52.06Z"/><path class="cls-1" d="M32.68,52.06a19.37,19.37,0,1,1,19.46-19A19.21,19.21,0,0,1,32.68,52.06Zm-.25-11c5,.11,8.64-3.19,8.81-7.93.17-5.07-3.22-8.87-8.07-9a8.32,8.32,0,0,0-8.86,8.29A8.27,8.27,0,0,0,32.43,41Z"/><path d="M32.43,41a8.27,8.27,0,0,1-8.12-8.68,8.32,8.32,0,0,1,8.86-8.29c4.85.17,8.24,4,8.07,9C41.07,37.85,37.4,41.15,32.43,41Z"/></svg>
            {{ school.postcodeCijfers }} {{ school.plaatsnaam }}</b>
        </span>
        <p class="content--preface" v-html="introTekst(school.toelichting)"></p>
        <p>
          <a :href="'index.html#/gegevens/' + school.initiatiefId" class="underline">
            <span @click="selectGegevens(school)">{{labels.LEES_VERDER}}</span>
          </a>
        </p>
        <div v-if="toonOuderverklaring(school, 'overzicht').titel" v-bind:class="toonOuderverklaring(school, 'overzicht').class">
          <div class="notification__content">
            <h2 class="notification__title"> {{ toonOuderverklaring(school, 'overzicht').titel }}</h2>
            <span v-if="toonOuderverklaring(school, 'overzicht').tekst" v-html="toonOuderverklaring(school, 'overzicht').tekst"></span>
            <div v-if="toonLinkStatusoverzicht1(school)">
              <a role="button" tabindex="0" class="link"  @click="selectGegevens(school), openModal(school)">{{labels.BEKIJK_BESLISSING}}</a>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div><ModalComponent /></div>
  </div>
</template>

<script>
import { toonDescription } from "../mixins/toonDescription";
import { mapGetters } from 'vuex';
import {steunInitiatief} from "../mixins/steunInitiatief";
import ModalComponent from "../components/Modal";

export default {
  name: 'initiatievenLijst',
  components:{
    ModalComponent
  },
  data() {
    return {
      modal: {}
    };
  },
  props: ["collection", "numberofrecords"],
  mixins: [toonDescription, steunInitiatief],
  computed: {
    ...mapGetters(["labels","selectedId", "gekozenInitiatief", "selectedInitiative"]),
    resultaat: function () {
      return this.numberofrecords === 1 ? "resultaat" : "resultaten";
    }
  },
  mounted() {
    if (window.System) {
      window.System.import('./libs/uno/dist/components/modal/modal.min.js').then((module) => {
        this.modal = new module.Modal(document.getElementById('myModal'));
      });
    }
  },
  methods: {
		getYearFormatted(initiative) {
			return new Date(initiative.datumtijdOpgevoerd).getFullYear();
		},
    selectGegevens(initiative) {
      this.$store.dispatch('SELECT_INITIATIVE', initiative)
    },
    openModal(initiative) {
      if (this.$matomo) {
        this.$matomo.trackEvent("Initiatief-scholen", "bekijkbeslissing", initiative.naam);
      }
      this.modal.open();
    }
  }
}
</script>
